<template>
  <div class="relative grid gap-2" id="hero">
    <div class="bg-black relative -mx-[4vw] lg:mx-0 lg:rounded lg:overflow-hidden">
      <div class="absolute z-10 top-1/2 -translate-y-1/2 w-full p-6 md:p-[2vw] grid gap-4">
        <div class="relative z-10 w-40 h-28 invert mx-auto" v-if="restaurant.logo">
          <AtomImage class="h-full !object-contain object-center-center" :src="useCloudinaryImage(restaurant.logo, 300, null, 'fit,e_trim')" :alt="restaurant.name" />
        </div>
        <div class="text-white text-center grid gap-2" v-if="restaurant.bookable">
          <div class="font-heading font-medium text-xl" v-html="restaurant.address" />
          <div class="font-medium text-sm" v-html="restaurant.city" />
        </div>
        <div class="text-center mx-auto" v-if="restaurant.bookable">
          <button class="button-coral w-44" @click="useOpenWidget(restaurant.hash)">{{ $t('shared.bookTable') }}</button>
        </div>
      </div>
      <div class="absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-25% from-black/40"></div>
      <div class="aspect-3/4 sm:aspect-video lg:aspect-widescreen">
        <AtomImage class="!object-cover sm:hidden" :src="imageMobile" :alt="restaurant.name" />
        <AtomImage class="!object-cover hidden sm:block" :src="imageDesktop" :alt="restaurant.name" />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  restaurant: {
    type: Object,
    default: () => {}
  }
})

const imageMobile = useCloudinaryImage(props.restaurant.cover, 600, 800)
const imageDesktop = useCloudinaryImage(props.restaurant.cover, 1200, 600)
</script>